var moduleMap = {
	"./UpfitterRecordsPage": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_react_jsx-runtime_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_fcamna_shared-icons_fcamna_shared-icons"), __webpack_require__.e("webpack_sharing_consume_default_fcamna_shared-component-foundations_fcamna_shared-component-f-976fe7"), __webpack_require__.e("src_styles_common_scss-src_api_UpfitterProfileAPI_ts-src_components_common_UPButton_tsx-src_c-376bfe"), __webpack_require__.e("src_pages_UpfitterRecordPage_UpfitterRecordPage_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/pages/UpfitterRecordPage/UpfitterRecordPage */ "./src/pages/UpfitterRecordPage/UpfitterRecordPage.tsx")))));
	},
	"./UpfitterProfileDetailPage": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_react_jsx-runtime_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react"), __webpack_require__.e("webpack_sharing_consume_default_fcamna_shared-component-foundations_fcamna_shared-component-f-976fe7"), __webpack_require__.e("src_styles_common_scss-src_api_UpfitterProfileAPI_ts-src_components_common_UPButton_tsx-src_c-376bfe"), __webpack_require__.e("webpack_sharing_consume_default_react-router_react-router"), __webpack_require__.e("src_pages_UpfitterRecordDetailPage_UpfitterRecordDetailPage_tsx")]).then(() => (() => ((__webpack_require__(/*! ./src/pages/UpfitterRecordDetailPage/UpfitterRecordDetailPage */ "./src/pages/UpfitterRecordDetailPage/UpfitterRecordDetailPage.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});